import { render, staticRenderFns } from "./MemberTypeForm.vue?vue&type=template&id=561d4ada"
import script from "./MemberTypeForm.vue?vue&type=script&lang=js"
export * from "./MemberTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports